<template>
<div :class="['plan-empty-overlay', { 'screen-lg': this.onTabletUp }]" v-if="this.currentPlan.isEmpty && this.isPlanEmpty">
  <!-- <img class="empty-plan-grid" src="@assets/images/empty-plan-grid.svg" /> -->
  <div class="plan-empty-content-wrapper">
    <h4>{{ $t('calender.noRecipeTitle') }}</h4>
    <p
      >{{
        $t('calender.noRecipeDescription', {
          plan: appConfig.PLANS_ENABLED ? $t('calender.noRecipeDescription2') : $t('calender.noRecipeDescription3'),
        })
      }}
    </p>
    <div class="plan-empty-actions">
      <BaseButton type="button" class="btn btn-thin " @click="viewPlans" v-if="appConfig.PLANS_ENABLED">
        {{ $t('calender.buttonStartWithMeal') }}
      </BaseButton>
      <BaseButton type="button" class="btn btn-ghost btn-thin" @click="start">
        {{ $t('calender.buttonBuildPlan') }}
      </BaseButton>
    </div>
  </div>
</div>
</template>

<script>
import { planComputed, planMethods, kitchenDrawerMethods } from '@state/helpers';
import appConfig from '@src/app.config.ES6';

export default {
  components: {},
  props: {
    onTabletUp: {
      type: Boolean,
    },
  },
  data() {
    return {
      appConfig,
    };
  },
  computed: {
    ...planComputed,
  },
  mounted() {},
  methods: {
    ...kitchenDrawerMethods,
    ...planMethods,
    start() {
      this.setIsPlanEmpty(); // Hide overlay
    },
    viewPlans() {
      this.toggleDrawer();
      this.navigateDeeper({
        title: 'Plans',
        component: 'Plans',
        context: 'drawerModal',
      });
      setTimeout(() => {
        this.start();
      }, 2500);
    },
  },
};
</script>

<style lang="scss" scoped>
@import 'theme.scss';

.plan-empty-overlay {
  align-items: center;
  background-color:$color-background-app;
  bottom: 0;
  display: flex;
  justify-content: center;
  left: 0;
  padding: 2rem;
  position: absolute;
  right: 0;
  top: 0;
  width: 100vw;
  z-index: 1;

  h4 {
    font-size: 1.7rem;
    font-weight: 600 !important;
    margin-bottom: 2.4rem;
  }

  .empty-plan-grid {
    left: 5rem;
    position: absolute;
    top: 11rem;
    width: 100%;
    z-index: -1;
  }

  .plan-empty-content-wrapper {
    align-items: center;
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    text-align: center;

    p {
      font-size: 1.7rem;
      line-height: 1.3;
      margin-bottom: 4rem;
    }

    .plan-empty-actions {
      display: flex;
      flex-direction: column;

      .btn {
        font-size: 1.6rem;

        &:first-of-type {
          margin: 0 auto 1rem;
        }
      }

      .btn-ghost {
        background-color: $color-background-app
      }
    }
  }

  &.screen-lg {
    justify-content: flex-start;

    .empty-plan-grid {
      // iPad up
      @include media('xl', null) {
        width: 50%;
      }

      // iPad Pro up
      @include media('xxl', null) {
        width: 30%;
      }
    }

    .plan-empty-content-wrapper {
      width: 50%;

      // iPad Pro up
      @include media('xxl', null) {
        left: 10%;
        position: absolute;
      }
    }
  }
}
</style>
